import React from 'react';

import Board from 'components/Board';
import Lobby from 'components/Lobby';

export default () => <Lobby>{(props) => <Board project="ffyn" {...props} />}</Lobby>;
